<footer>
    <div class="footer-main">
        <div class="footer-row">
            <div class="w-100 d-block d-md-none mb-5">
                <h5>Subscribe to our newsletter</h5>
                <div class="footer-form">
                    <div class="cst-form-group">
                        <input type="text" name="" id="" [(ngModel)]="utils.subscribedEmail"
                            placeholder="Enter your Email" class="cst-form-control">
                    </div>
                    <div>
                        <button (click)="triggerSubscribeEvent()" [disabled]="utils.subscribedEmail==''"
                            class="grey-btn border-0">Subscribe</button>
                    </div>
                </div>
            </div>
            <div class="footer-col">
                <div class="footer-sub-row">
                    <div class="footer-sub-col">
                        <div>
                            <h5 (click)="accordionHandler(1)" [ngClass]="{'active': openAccordionIndex == 1}">About
                                Luminous</h5>
                            <ul>
                                <li><a [routerLink]="['/about-us']">About Us</a></li>
                                <li><a [routerLink]="['/global-presence']">Global presence</a></li>
                                <li><a [routerLink]="['/csr']">CSR</a></li>
                                <li><a [routerLink]="['/investors']">Investors</a></li>
                                <li><a [routerLink]="['/career']">Careers</a></li>
                                <li><a [routerLink]="['/customer-support']">Support</a></li>
                                <li><a [routerLink]="['/trust-charter']">Ethics & compliance</a></li>
                                <li><a [routerLink]="['/blog-corner']">Blog</a></li>
                                <li><a [routerLink]="['/enquiry']">Business Enquiry</a></li>
                                <li><a [routerLink]="['/press-media']">Press & Media</a></li>

                            </ul>
                        </div>
                        <div>
                            <h5 (click)="accordionHandler(2)" [ngClass]="{'active': openAccordionIndex == 2}">Luminous
                                Care</h5>
                            <ul>
                                <li><a [routerLink]="['/book-complaint']">Book Your Complaint</a></li>
                                <li><a [routerLink]="['/installation']">Installation Help</a></li>
                                <li><a (click)="analyticsService?.triggerLoadInitiated('Footer')"
                                        [routerLink]="['/service-care-pack']">Service Care
                                        Pack</a></li>
                                <li><a routerLink="/track-order">Track Order Status</a></li>
                                <li><a [routerLink]="['/warranty-registration']">Register a product</a></li>
                                <li><a [routerLink]="['/service-center-locator']">Service Center Locator</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="footer-sub-col flex1-5">
                        <div>
                            <h5 (click)="accordionHandler(3)" [ngClass]="{'active': openAccordionIndex == 3}">Our
                                Policies</h5>
                            <ul>
                                <li><a [routerLink]="['/shipping-policy']">Shipping & Payments</a></li>
                                <li><a [routerLink]="['/cancellation-return']">Cancellation & Returns</a></li>
                                <li><a [routerLink]="['/terms-conditions']">Terms & Conditions</a></li>
                                <li><a [routerLink]="['/luminous-offers']">Luminous Offers</a></li>
                                <li><a [routerLink]="['/terms-conditions-offers']">Terms & Conditions (Offers)</a></li>
                                <li><a [routerLink]="['/privacy-policy']">Privacy Policy</a></li>
                                <li><a [routerLink]="['/bulk-order']">Bulk Orders</a></li>
                                <!-- <li><a [routerLink]="['/consumer-offer']">Consumer Offers</a></li> -->
                            </ul>
                        </div>
                        <div>
                            <h5 (click)="accordionHandler(4)" [ngClass]="{'active': openAccordionIndex == 4}">Useful
                                Links</h5>
                            <ul>
                                <li><a (click)="analyticsService?.triggerLoadInitiated('Footer')"
                                        [routerLink]="['/load-calculator']">Load
                                        Calculator</a></li>
                                <!-- <li><a [routerLink]="['/solar-calculator']">Solar
                                        Calculator</a></li> -->
                                <li><a [routerLink]="['/store-locator']">Store Locator</a></li>
                                <li><a [href]="utils.webUrlForDistributor">Seller Panel</a></li>
                                <li><a [routerLink]="['/warranty-cards']">Warranty Cards</a></li>
                            </ul>
                        </div>
                        <div>
                            <h5 (click)="accordionHandler(5)" [ngClass]="{'active': openAccordionIndex == 5}">
                                Infringement Policy</h5>
                            <ul>
                                <li>
                                    <label class="cursorText"> Any kind of infringement of brand
                                        guidelines is
                                        subject to legal action. Report infringement cases by sending images on
                                    </label>
                                </li>
                                <li>
                                    <a href="mailto:brand@luminousindia.com"> brand&#64;luminousindia.com</a>
                                </li>
                                <!-- <li><a href="javascript:void(0)">Seller Panel</a></li> -->
                            </ul>
                        </div>
                    </div>
                    <div class="footer-sub-col flex1-5">
                        <div>
                            <h5 (click)="accordionHandler(6)" [ngClass]="{'active': openAccordionIndex == 6}">Get In
                                Touch</h5>
                            <ul>
                                <li><a routerLink="/contact-us">Contact Us</a></li>
                                <li (click)="analyticsService?.trackContactUs()"><a href="tel:8906008008">
                                        Online Sale Support for Power Backup & Energy Solutions: <b>+91-8906008008</b></a>
                                </li>
                                <li (click)="analyticsService?.trackContactUs()"><a href="tel:9999933039">Customer
                                        Care: <b>9999933039</b></a>
                                </li>
                                <li (click)="analyticsService?.trackContactUs()"><a href="tel:9990299902">Energy
                                        Solutions:
                                        <b>9990299902</b></a>
                                </li>
                                <li><a href="mailto:energysolution@luminousindia.com">Energy Solutions Email:
                                        energysolution&#64;luminousindia.com</a>
                                </li>
                                <li><a href="mailto:sales@luminous-global.com">Global Queries:
                                        sales&#64;luminous-global.com</a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h5 (click)="accordionHandler(7)" [ngClass]="{'active': openAccordionIndex == 7}">Head
                                Office</h5>
                            <ul>
                                <li><a target="_blank"
                                        href="http://maps.google.com/?q=Luminous Power Technologies Pvt. Ltd. Plot No. 150, Sector 44,Gurgaon, Haryana - 122003">
                                        Luminous Power Technologies Pvt. Ltd.
                                        Plot No. 150, Sector 44,
                                        Gurgaon, Haryana - 122003</a></li>
                            </ul>
                        </div>
                        <div>
                            <h5 (click)="accordionHandler(8)" [ngClass]="{'active': openAccordionIndex == 8}">Registered
                                Office</h5>
                            <ul>
                                <li><a target="_blank"
                                        href="http://maps.google.com/?q=C-56, Mayapuri Industrial Area, Phase- II,Mayapuri, New Delhi 110064">
                                        C-56, Mayapuri Industrial Area, Phase- II,
                                        Mayapuri, New Delhi 110064</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="footer-sub-col flex2 d-none d-md-block">
                        <div>
                            <h5>Subscribe to our newsletter</h5>
                            <div class="footer-form">
                                <div class="cst-form-group">
                                    <input type="text" name="" id="" [(ngModel)]="utils.subscribedEmail"
                                        placeholder="Enter your Email" class="cst-form-control">
                                </div>
                                <div>
                                    <button (click)="triggerSubscribeEvent()" [disabled]="utils.subscribedEmail==''"
                                        class="grey-btn border-0">Subscribe</button>
                                </div>
                            </div>
                        </div>
                        <div class="right-sub-col social-main d-none d-md-block">
                            <ng-container *ngTemplateOutlet="connectCare">
                            </ng-container>
                        </div>
                        <div class="social-icons">
                            <h5>Follow Us</h5>
                            <ng-container *ngTemplateOutlet="socialIcons">
                            </ng-container>
                        </div>
                        <div class="social-icons">
                            <h5>Payment secured by</h5>
                            <div class=" image-set">
                                <ul>
                                    <li class="paymentSecured"><img class="cc-image" width="119" height="100"
                                            loading="lazy" [src]="environment?.blobUrl+'/assets/images/cc-avenue.svg'"
                                            alt="CC-Avenue Logo | Luminous"></li>
                                </ul>
                                <ul>
                                    <li class="paymentSecuredSnap"><img width="131" height="100" loading="lazy"
                                            [src]="environment?.blobUrl+'/assets/images/snapmint.svg'"
                                            alt="Snapmint Logo | Luminous"></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-sub-col social-main d-block d-md-none">
                <ng-container *ngTemplateOutlet="connectCare">
                </ng-container>
                <div class="social-icons">
                    <h5>Follow Us</h5>
                    <ng-container *ngTemplateOutlet="socialIcons">
                    </ng-container>
                </div>
                <div class="social-icons">
                    <h5>Payment secured by</h5>
                    <div class=" image-set">
                        <ul>
                            <li class="paymentSecured">
                                <img height="18" width="119" loading="lazy"
                                    [src]="environment?.blobUrl+'/assets/images/cc-avenue.svg'"
                                    alt="CC-Avenue Logo | Luminous">
                            </li>
                        </ul>
                        <ul>
                            <li class="paymentSecuredSnap"><img height="18" width="119" loading="lazy"
                                    [src]="environment?.blobUrl+'/assets/images/snapmint.svg'"
                                    alt="Snapmint Logo | Luminous"></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <p class="copyRight">Copyright Luminous India 2022. All rights reserved.</p>
    </div>
</footer>

<ng-template #connectCare>
    <a (click)="analyticsService?.triggerSupportContactEvent('connect@luminousindia.com','Footer')"
        href="mailto:connect@luminousindia.com" class="footer-contact">
        <img height="28" width="28" loading="lazy" [src]="environment?.blobUrl+'/assets/icons/mail-white.svg'"
            alt="Mail | Luminous">
        <p>connect&#64;luminousindia.com
        </p>
    </a>
    <a (click)="analyticsService?.triggerSupportContactEvent(7042833939,'Footer')"
        href="https://api.whatsapp.com/send?phone=7042833939" target="_blank" class="footer-contact"> <img height="28"
            width="28" loading="lazy" [src]="environment?.blobUrl+'/assets/icons/whatsapp-white.svg'"
            alt="Whatsapp | Luminous">
        <p>Luminous Service: +91-7042833939</p>
    </a>
</ng-template>
<ng-template #socialIcons>
    <ul class="socialIcons">
        <li> <a class="p-0" role="button" target="_blank" aria-label="LinkedIn"
                href="https://in.linkedin.com/company/luminous-power-technologies-p-ltd"
                (click)="socialMediaClickEventTrigger('LinkedIn')">
                <div class="bg-linkedin"></div>
            </a>
        </li>
        <li><a class="p-0" role="button" target="_blank"
           (click)="socialMediaClickEventTrigger('Instagram')"  aria-label="Instagram"
                href="https://www.instagram.com/luminous_officials/?hl=en">
                <div class="bg-instagram"></div>
            </a>
        </li>
        <li><a class="p-0" role="button" (click)="socialMediaClickEventTrigger('Twitter')" target="_blank"
          aria-label="Twitter"
                href="https://twitter.com/myluminous?lang=en">
                <div class="bg-twitter"></div>
            </a>
        </li>
        <li><a class="p-0" role="button" target="_blank" (click)="socialMediaClickEventTrigger('Youtube')"
          aria-label="Youtube"
                href=" https://www.youtube.com/channel/UCw6k_Tm3O0MI23ah2SBYB3Q">
                <div class="bg-youtube"></div>
            </a></li>
    </ul>
</ng-template>